module.exports = __webpack_public_path__ + "media/images/menu/luna-b992eee632afdb72bc85bb4c36ec8a3a.jpg";